import { LenderApprovalStatus } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';
import { SWRConfig } from 'swr';

import { ChangeLenderApprovalStatusActionDialog } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/components/ChangeLenderApprovalStatusActionDialog';
import { ResendContractSignatureToBorrowerDialog } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/components/ResendContractSignatureToBorrowerDialog';
import { SendContractSignatureToBorrowerDialog } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/components/SendContractSignatureToBorrowerDialog';
import { SetContractSignedDialog } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/components/SetContractSignedDialog';
import { SetLenderRequestIdActionDialog } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/components/SetLenderRequestIdActionDialog';
import { UnSignContractActionDialog } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/components/UnSignContractActionDialog';
import { LoanApplicationAction } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/types/LoanApplicationAction';

interface LoanApplicationActionDialogProps {
  loanId: string;
  loanApplicationId: string;
  setLoanApplicationAction: (e) => void;
  loanApplicationAction: LoanApplicationAction;
  lenderApprovalStatus?: LenderApprovalStatus | null;
  useDialogProps: UseDialogProps;
}

export const LoanApplicationActionDialog = ({
  loanId,
  loanApplicationId,
  setLoanApplicationAction,
  loanApplicationAction,
  lenderApprovalStatus,
  useDialogProps,
}: LoanApplicationActionDialogProps) => (
  <>
    <SWRConfig
      value={{
        revalidateOnMount: false,
      }}
    >
      {loanApplicationAction === LoanApplicationAction.UN_SIGN_CONTRACT && (
        <UnSignContractActionDialog
          loanId={loanId}
          loanApplicationId={loanApplicationId}
          setLoanApplicationAction={setLoanApplicationAction}
          useDialogProps={useDialogProps}
        />
      )}
      {loanApplicationAction === LoanApplicationAction.CHANGE_LENDER_APPROVAL_STATUS && (
        <ChangeLenderApprovalStatusActionDialog
          loanId={loanId}
          loanApplicationId={loanApplicationId}
          setLoanApplicationAction={setLoanApplicationAction}
          useDialogProps={useDialogProps}
          lenderApprovalStatus={lenderApprovalStatus}
        />
      )}
      {loanApplicationAction === LoanApplicationAction.SET_LENDER_REQUEST_ID && (
        <SetLenderRequestIdActionDialog
          loanId={loanId}
          loanApplicationId={loanApplicationId}
          setLoanApplicationAction={setLoanApplicationAction}
          useDialogProps={useDialogProps}
        />
      )}
      {loanApplicationAction === LoanApplicationAction.RESEND_CONTRACT_SIGNATURE_TO_BORROWER && (
        <ResendContractSignatureToBorrowerDialog
          loanApplicationId={loanApplicationId}
          useDialogProps={useDialogProps}
        />
      )}
      {loanApplicationAction === LoanApplicationAction.SEND_CONTRACT_SIGNATURE_TO_BORROWER && (
        <SendContractSignatureToBorrowerDialog loanId={loanId} useDialogProps={useDialogProps} />
      )}
      {loanApplicationAction === LoanApplicationAction.SET_CONTRACT_SIGNED && (
        <SetContractSignedDialog loanApplicationId={loanApplicationId} useDialogProps={useDialogProps} />
      )}
    </SWRConfig>
  </>
);

export interface UseDialogProps {
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog: () => void;
}
